import { render } from "./ClassListTableRow.vue?vue&type=template&id=af240f20&scoped=true&ts=true"
import script from "./ClassListTableRow.vue?vue&type=script&lang=ts"
export * from "./ClassListTableRow.vue?vue&type=script&lang=ts"

import "./ClassListTableRow.vue?vue&type=style&index=0&id=af240f20&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af240f20"]])

export default __exports__